export const eWebinarButtonHTML = `
  <div
    id="w1761735293013"
    class="ewebinar__Widget ewebinar__ThankYou_Root"
    style="padding: 2px 0 14px; width: 100%; max-width: 100%;"
  >
    <div class="ewebinar__Widget ewebinar__ThankYou ewebinar__ThankYou--loading">
      <div
        class="ewebinar__ThankYou__Button__Wrap"
        style="--primary-color: #ff5e45ff; --primary-color-readable: #ffffff; text-decoration: none; display: flex; width: 100%; justify-content: center;"
      >
        <button
          type="button"
          class="ewebinar__ThankYou__Button"
          style="border-radius: 50px; background: #ff5e45ff; color: #ffffff; font-size: 14px; max-width: 100% !important; width: auto !important; margin: initial; font-family: unset;"
        >
          <div class="ewebinar__Dots ewebinar__ThankYou__Button__Loading">
            <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
            <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
            <span class="ewebinar__LoadingDot" style="background: #ffffff"></span>
          </div>
          Go to session now
        </button>
      </div>
    </div>
  </div>
`;
